<template>
  <div style="height: 100%;">
    <div style="position: fixed; top: 55px; right: 10px; z-index: 1000">
      <div id="wrappers">
        <div class="input-data">
          <input
            type="text"
            v-model="Text"
            @keyup.enter="GetCYClass()"
            required
          />
          <div class="underline">
            <i
              class="el-icon-circle-close"
              v-show="Text.length > 0"
              style="
                position: absolute;
                top: -30px;
                right: 60px;
                color: #9fa1a7;
              "
              @click="Text = ''"
            ></i>
            <el-button
              type="primary"
              style="position: absolute; top: -35px; right: 1px"
              size="mini"
              icon="el-icon-search"
              @click="GetCYClass()"
            ></el-button>
          </div>
          <label>{{ $t('All.品名') }}/{{ $t('All.料号') }}</label>
        </div>
      </div>
    </div>
    <div style="height: calc(100% - 40px);">
      <template>
        <el-table :data="formData" style="width: 100%" height="100%">
        <el-table-column prop="Date" :label="$t('All.日期')" width="160">
        </el-table-column>
        <el-table-column prop="Product_name" :label="$t('All.品名')"> </el-table-column>
        <el-table-column prop="Gg" :label="$t('All.规格')"> </el-table-column>
        <el-table-column prop="Item_no" :label="$t('All.料号')"> </el-table-column>
        <el-table-column prop="Lot" :label="$t('All.Lot号')"> </el-table-column>
        <el-table-column align="center" prop="Rdate" :label="$t('All.入库日期')">
            <template slot-scope="scope">
            {{scope.row.Rdate|formatDate('yyyy-MM-dd')}}
            </template>
          </el-table-column>
        <el-table-column align="center" prop="Cdate" :label="$t('All.生产日期')">
          <template slot-scope="scope">
            {{scope.row.Cdate|formatDate('yyyy-MM-dd')}}
            </template>
        </el-table-column>
        <el-table-column prop="Scsl" :label="$t('All.生产数量')"> </el-table-column>
        <el-table-column prop="DScsl" :label="this.$t('All.单箱数量')"> </el-table-column>
        <el-table-column prop="Gd" :label="$t('All.工单号')"> </el-table-column>
        <el-table-column prop="Jt" :label="$t('All.机台')"> </el-table-column>
        <el-table-column prop="Czu" :label="$t('All.操作员')"> </el-table-column>
        <el-table-column align="center" :label="$t('All.状态')" width="120">
            <template slot-scope="scope">
              <el-tag :type="scope.row.State === 0?'success':'danger'" effect="dark">{{ scope.row.State === 0 ? $t('All.有效') : $t('All.失效') }}</el-tag>
            </template>
          </el-table-column>
        <el-table-column align="center" prop="Type" :label="$t('All.操作类型')" width="110px">
            <template slot-scope="scope">
              <el-tag>{{ scope.row.Type === 0?$t('All.生产'):scope.row.Type === 2?$t('All.拆包'):scope.row.Type === 3?$t('All.退料'):scope.row.Type === 1?$t('All.补码'):'' }}</el-tag>
            </template>
        </el-table-column>
      </el-table>
      </template>
    </div>
    <el-pagination
    style="text-align: center; padding: 6px;"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageindex"
      :page-sizes="[10, 100, 200, 300]"
      :page-size="page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
  </div>
</template>
<script>
export default {
  components: {},
  props: [],
  data () {
    return {
      formData: [],
      total: 0,
      page_size: 10,
      pageindex: 1,
      Text: ''
    }
  },
  filters: {
    formatDate: function (value, args) {
      var dt = new Date(value)
      if (args === 'yyyy-M-d') { // yyyy-M-d
        const year = dt.getFullYear()
        const month = dt.getMonth() + 1
        const date = dt.getDate()
        return `${year}-${month}-${date}`
      } else if (args === 'yyyy-M-d H:m:s') { // yyyy-M-d H:m:s
        const year = dt.getFullYear()
        const month = dt.getMonth() + 1
        const date = dt.getDate()
        const hour = dt.getHours()
        const minute = dt.getMinutes()
        const second = dt.getSeconds()
        return `${year}-${month}-${date} ${hour}:${minute}:${second}`
      } else if (args === 'yyyy-MM-dd') { // yyyy-MM-dd
        const year = dt.getFullYear()
        const month = (dt.getMonth() + 1).toString().padStart(2, '0')
        const date = dt.getDate().toString().padStart(2, '0')
        return `${year}-${month}-${date}`
      } else { // yyyy-MM-dd HH:mm:ss
        const year = dt.getFullYear()
        const month = (dt.getMonth() + 1).toString().padStart(2, '0')
        const date = dt.getDate().toString().padStart(2, '0')
        const hour = dt.getHours().toString().padStart(2, '0')
        const minute = dt.getMinutes().toString().padStart(2, '0')
        const second = dt.getSeconds().toString().padStart(2, '0')
        return `${year}-${month}-${date} ${hour}:${minute}:${second}`
      }
    }
  },
  computed: {},
  watch: {},
  created () {
    this.GetCYClass()
  },
  mounted () {},
  methods: {
    async GetCYClass () {
      const intfs = {
        Pageindex: this.pageindex,
        PageSize: this.page_size,
        UserData: this.$store.state.Login,
        Text: this.Text
      }
      const { data: res } = await this.$http.post(
        '/api/Semifinished/GetCYClass',
        intfs
      )
      if (res.status !== 200) return this.$message.error(res.msg)
      this.total = res.response.TotalCount
      this.formData = res.response.CYClass
    },
    handleSizeChange (val) {
      this.page_size = val
      this.GetCYClass()
    },
    handleCurrentChange (val) {
      this.pageindex = val
      this.GetCYClass()
    }
  }
}
</script>
<style lang="less" scoped>
/** talbe表头置顶**/
/deep/ .el-table {
    overflow: visible;
 }

 /deep/ .el-table__header-wrapper {
    position: sticky;
    top: 0px;
    z-index: 10;
 }
</style>
